import { cn } from '@sea-snag/ui';
import { Check } from 'lucide-react';

interface WizardStepperProps {
  steps: string[];
  currentStep: number;
  onStepClick: (step: number) => void;
  completedSteps?: Set<number>;
}

export function WizardStepper({
  steps,
  currentStep,
  onStepClick,
  completedSteps = new Set(),
}: WizardStepperProps) {
  return (
    <nav className="flex flex-col gap-1" aria-label="Wizard steps">
      {steps.map((label, idx) => {
        const isCurrent = idx === currentStep;
        const isCompleted = completedSteps.has(idx);
        const isClickable = isCompleted || idx < currentStep;

        return (
          <button
            key={label}
            type="button"
            disabled={!isClickable && !isCurrent}
            onClick={() => isClickable && onStepClick(idx)}
            className={cn(
              'flex items-center gap-3 rounded-md px-3 py-2.5 text-sm text-left transition-colors',
              isCurrent && 'bg-accent font-medium',
              isClickable && !isCurrent && 'hover:bg-accent/50 cursor-pointer',
              !isClickable && !isCurrent && 'text-muted-foreground opacity-60'
            )}
          >
            <span
              className={cn(
                'flex size-7 shrink-0 items-center justify-center rounded-full text-xs font-medium border',
                isCurrent && 'border-primary bg-primary text-primary-foreground',
                isCompleted && !isCurrent && 'border-primary bg-primary/10 text-primary',
                !isCurrent && !isCompleted && 'border-muted-foreground/30'
              )}
            >
              {isCompleted && !isCurrent ? <Check className="size-3.5" /> : idx + 1}
            </span>
            {label}
          </button>
        );
      })}
    </nav>
  );
}
